// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.view-card-scroll-widget[data-v-570f2172] {\n  min-height: 100% !important;\n  max-height: 100% !important;\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none; /* Firefox */\n}\n.view-card-scroll-widget[data-v-570f2172]::-webkit-scrollbar {\n  display: none; /* Safari and Chrome */\n}\n.paginator-container[data-v-570f2172] {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 3;\n}\n", ""]);
// Exports
module.exports = exports;
